<script>
/**
 * Original Author: Dallin Anderson
 * Original Team: BFFs
 */
import NsTab from './NsTab.vue';
// This component wraps the tabs and adds a selected prop and event to each tab

export default {
  name: 'NsTabsWrapper',
  props: {
    selected: {
      type: [String, Number],
      default: null,
    },
    useHover: Boolean,
  },
  methods: {
    handleClick(index) {
      if (!this.useHover) {
        this.$emit('select', index);
      }
    },
    handleMouseenter(index) {
      if (this.useHover) {
        this.$emit('select', index);
      }
    },
  },
  render(createElement) {
    if (!this.$slots.default) {
      return null;
    }

    return createElement(
      'div',
      {
        class: this.$style.container,
      },
      this.$slots.default
        .filter((slot) => slot.tag)
        .map((child, index) => {
          return createElement(
            NsTab,
            {
              props: {
                isSelected: index === this.selected,
              },
              on: {
                click: () => this.handleClick(index),
                mouseenter: () => this.handleMouseenter(index),
              },
            },
            child.componentOptions.children
          );
        })
    );
  },
};
</script>

<style lang="scss" module>
.container {
  display: flex;
}
</style>
